import { FilterAltRounded, ReplayRounded, SearchRounded } from "@mui/icons-material";
import { Button, Collapse, Grid, OutlinedInput, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { areObjectsEqual } from "../utils/FilterUtils";


interface AdvancedFilterProps {
    schema: any,
    fields?: any,
    defaultValues: any,
    customDefaultValues?: any,
    onSubmit: (data: any) => void,
    onReset: Function,
    mainFields?: any,
    searchInput?: any,
    setSearchInput?: Function
}

const AdvancedFilter = ({
                            schema,
                            fields,
                            defaultValues,
                            customDefaultValues,
                            onSubmit,
                            onReset,
                            mainFields,
                            searchInput,
                            setSearchInput,
                        }: AdvancedFilterProps) => {

    const {t} = useTranslation('finance');

    const [advancedFilters, setAdvancedFilters] = useState(false);

    const {watch, handleSubmit, control, reset, formState, setValue} = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(schema)
    });

    const watchAll = watch();
    let disabledReset = customDefaultValues && customDefaultValues ? areObjectsEqual(customDefaultValues, defaultValues) : true;

    return (
        <Paper elevation={1} sx={{padding: "16px"}}>
            <form onSubmit={
                handleSubmit(data => {
                    onSubmit(data);
                    setAdvancedFilters(false);
                }, (errors, event) => {
                    console.debug(errors);
                })
            } noValidate>
                <Grid container justifyContent={"space-between"} spacing={3}>
                    {setSearchInput &&
                        <Grid item xs={12} sm={6} md={3}>
                            <OutlinedInput
                                size="small" fullWidth
                                startAdornment={<SearchRounded/>}
                                inputProps={{maxLength: 120}}
                                value={searchInput}
                                onChange={(event) => {
                                    setSearchInput(event?.target.value)
                                }}
                            />
                        </Grid>}
                    {!setSearchInput && mainFields &&
                        Object.keys(mainFields).map(f =>
                            <Grid item xs={12} sm={6} md={Object.keys(mainFields).length === 2 ? 4 : 3} key={f}>
                                <Controller
                                    control={control}
                                    name={f}
                                    render={({field, fieldState: {error}, formState}) => (
                                        mainFields[f](field, error, formState, watchAll, setValue)
                                    )}
                                />
                            </Grid>
                        )}
                        <Grid item container xs={12} sm={mainFields != null && Object.keys(mainFields).length == 2 ? 12 : 6} md={3} justifyContent={"flex-end"} alignItems={"center"}>
                        <Stack direction={"row"} alignItems={"center"}>
                            <Button disabled={(!searchInput && !formState.isDirty) && disabledReset}
                                    variant="text" size="small" color="accent"
                                    startIcon={<ReplayRounded/>}
                                    onClick={() => { 
                                        onReset();
                                        defaultValues = customDefaultValues ? customDefaultValues : defaultValues;
                                        reset(defaultValues);
                                        if (setSearchInput) {
                                            setSearchInput("");
                                        }
                                        setAdvancedFilters(false)
                                    }}>
                                {t('advancedfilter.reset')}
                            </Button>
                            {(fields && Object.keys(fields).length >0) &&
                                <>
                                    {advancedFilters?
                                        <Button variant="text" size="small" color="accent"
                                                startIcon={<FilterAltRounded/>}
                                                onClick={() => {
                                                    setAdvancedFilters(false)
                                                }}>
                                            {t('advancedfilter.close')}
                                        </Button>
                                        :
                                        <Button variant="text" size="small" color="accent"
                                                startIcon={<FilterAltRounded/>}
                                                onClick={() => {
                                                    setAdvancedFilters(true)
                                                }}>
                                            {t('advancedfilter.label')}
                                        </Button>
                                    }
                                </>
                            }
                            <Button type={'submit'} size={'icon'} color={'accent'}><SearchRounded/></Button>
                        </Stack>
                    </Grid>
                </Grid>
                {fields && <Collapse in={advancedFilters}>
                    <Grid container spacing={1} marginTop={5}>
                        {Object.keys(fields).map(f =>
                            <Grid item xs={12} sm={6} md={3} key={f}>
                                <Controller
                                    control={control}
                                    name={f}
                                    render={({field, fieldState: {error}, formState}) => (
                                        fields[f](field, error, formState, watchAll, setValue)
                                    )}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Collapse>}
            </form>
        </Paper>
    )
}

export default AdvancedFilter;